module.exports = __webpack_public_path__ + "img/microsite-TH.19b476ef.gif";